import * as tslib_1 from "tslib";
import DraftSaveTime from './DraftSaveTime';
import { CommandBar } from '@uifabric/experiments/lib/CommandBar';
import { observer } from 'mobx-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import setShowSendDiscardAsIcon from 'owa-mail-compose-store/lib/actions/setShowSendDiscardAsIcon';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { onCommandBarDataReduced, onCommandBarDataGrown, } from 'owa-surface-actions';
var styles = require('./ComposeBottom.scss');
var classNames = require('classnames/bind').bind(styles);
var MIN_WIDTH_FOR_TEXT_BUTTON = 380;
var ComposeToolbar = /** @class */ (function (_super) {
    tslib_1.__extends(ComposeToolbar, _super);
    function ComposeToolbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setCommandBarRefs = function (ref) {
            if (ref) {
                _this.commandBar = ref;
                _this.commandBarDiv = ReactDOM.findDOMNode(_this.commandBar);
            }
        };
        return _this;
    }
    ComposeToolbar.prototype.render = function () {
        return (React.createElement("div", { className: classNames(styles.buttonBar) },
            this.renderSendDiscardButton(),
            this.renderCommandBar(),
            this.renderDraftSaveTime()));
    };
    ComposeToolbar.prototype.componentWillUnmount = function () {
        this.commandBar = null;
        this.commandBarDiv = null;
    };
    ComposeToolbar.prototype.renderSendDiscardButton = function () {
        var _this = this;
        var _a = this.props, viewState = _a.viewState, onSend = _a.onSend, onDiscard = _a.onDiscard;
        var sendClassName = classNames(styles.sendButton, {
            iconButton: viewState.showSendDiscardAsIcon,
        });
        var discardClassName = classNames(styles.discardButton, {
            iconButton: viewState.showSendDiscardAsIcon,
        });
        return (React.createElement("div", { className: styles.sendDiscard, ref: function (ref) { return (_this.sendDiscard = ref); } },
            React.createElement(PrimaryButton, { onClick: onSend, className: sendClassName }, viewState.showSendDiscardAsIcon ? (React.createElement(Icon, { iconName: "Send" /* Send */ })) : (strings.composeSendButton)),
            React.createElement(DefaultButton, { onClick: onDiscard, className: discardClassName }, viewState.showSendDiscardAsIcon ? (React.createElement(Icon, { iconName: "Delete" /* Delete */ })) : (strings.composeDiscardButton))));
    };
    ComposeToolbar.prototype.renderCommandBar = function () {
        var _a = this.props.commandBarData, items = _a.items, overflowItems = _a.overflowItems;
        return (React.createElement(CommandBar, { componentRef: this.setCommandBarRefs, items: items, overflowItems: overflowItems, elipisisIconProps: {
                iconName: "ChevronDown" /* ChevronDown */,
                styles: {
                    root: styles.commandBarOverflowIcon,
                },
            }, elipisisAriaLabel: strings.composeEllipsisAriaLabelText, className: styles.surfaceActionsCommandBar, buttonStyles: {
                root: styles.commandBarButton,
                rootChecked: styles.checkedCommandBarButton,
                rootDisabled: styles.disabledCommandBarButton,
                menuIcon: styles.commandBarMenuIcon,
            }, onDataReduced: onCommandBarDataReduced, onDataGrown: onCommandBarDataGrown }));
    };
    ComposeToolbar.prototype.renderDraftSaveTime = function () {
        return React.createElement(DraftSaveTime, { viewState: this.props.viewState });
    };
    ComposeToolbar.prototype.resize = function () {
        if (this.sendDiscard && this.commandBar && this.commandBarDiv) {
            var viewState = this.props.viewState;
            var showSendDiscardAsIcon = viewState.showSendDiscardAsIcon;
            var sendDiscardWidth = this.sendDiscard.clientWidth;
            // Trigger commandBar remeasure and get its width
            this.commandBar.remeasure();
            var toolbarWidth = this.commandBarDiv.clientWidth;
            // Calculate showSendDiscardAsIcon with the toolbarWidth and update the viewState if dirty
            showSendDiscardAsIcon = toolbarWidth + sendDiscardWidth < MIN_WIDTH_FOR_TEXT_BUTTON;
            if (showSendDiscardAsIcon != viewState.showSendDiscardAsIcon) {
                setShowSendDiscardAsIcon(viewState, showSendDiscardAsIcon);
            }
        }
    };
    ComposeToolbar = tslib_1.__decorate([
        observer
    ], ComposeToolbar);
    return ComposeToolbar;
}(React.Component));
export default ComposeToolbar;
//# sourceMappingURL=ComposeToolbar.js.map